import { createContext, useContext } from 'react';
import { IRouterPage } from '../interfaces/interfaces';

export interface IFlowContextProps {
    flow: IRouterPage[];
    flowBlocked: boolean;
    blockType: string | undefined;
    canContinue: (currentPage: IRouterPage) => boolean;
    getNextCustomerPage: (page: IRouterPage) => any;
    setFlowBlocked: (blocked: boolean) => void;
}

const FlowContext = createContext<IFlowContextProps>({} as IFlowContextProps);
export { FlowContext };
export const useFlowContext = () => useContext(FlowContext);
